import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import * as Chart from 'chart.js';

@Component({
  selector: 'sociuu-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
})
export class StatisticsComponent implements OnInit, OnChanges {
  @Input() statistics;
  @Input() currencySymbol;
  @Input() statsNum;
  isLoadingStats = false;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    this.isLoadingStats = !this.statsNum && this.statsNum !== 0;
  }
}
